import { createContext, useContext } from 'react'

/**
 * Shared welcome-dialog state, exposed to any component (e.g. the nav's
 * "Show welcome guide" button) that needs to reopen or reset the dialog
 * without prop-drilling through App.
 */
export interface WelcomeDialogContextType {
  showWelcome: boolean
  setShowWelcome: (show: boolean) => void
  dismissWelcome: () => void
  resetWelcome: () => void
}

export const WelcomeDialogContext = createContext<WelcomeDialogContextType | undefined>(undefined)

export function useWelcomeDialogContext(): WelcomeDialogContextType {
  const context = useContext(WelcomeDialogContext)
  if (!context) {
    throw new Error('useWelcomeDialogContext must be used within WelcomeDialogProvider')
  }
  return context
}
